import React from 'react';
import { SystemNotification } from '../SystemNotification';

//ex: Drainage Plane Inspection is expected to start in 1 days.
const reg = /^(.*)(\sis\sexpected\sto\sstart\sin\s)(.*)$/;
const parseNotification = message => {
  const result = (message || '').match(reg);
  return result || [message, null, message, null, null];
};

export default ({ notification, controller, taskUrl }) => {
  const [, taskName, message, days] = parseNotification(notification.get('message'));

  return (
    <SystemNotification
      key={notification.get('_id')}
      linkTo={taskUrl({
        jobId: notification.getIn(['data', 'jobId']),
        taskId: notification.getIn(['data', 'taskId']),
      })}
      time={notification.get('createdAt')}
      redDot={!notification.get('read')}
      markAsSeen={() => controller.markAsSeen(notification)}
    >
      {taskName ? <span className="text-dark">{taskName}</span> : null}
      {message}
      {days ? <span className="text-dark">{days}</span> : null}
    </SystemNotification>
  );
};
